/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Settings_TitleInputs */



/**
* | output |
* | --- |
* | "Live Captioning Settings" |
*
* @param {Live_Caption_Settings_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_settings_title = /** @type {((inputs?: Live_Caption_Settings_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Settings_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Paramètres de sous-titrage en direct")
	if (locale === "de") return /** @type {LocalizedString} */ ("Live-Untertitelungseinstellungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impostazioni dei sottotitoli in tempo reale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Настройки субтитров в реальном времени")
	if (locale === "es") return /** @type {LocalizedString} */ ("Configuración de subtítulos en directo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("实时字幕设置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ライブキャプション設定")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लाइव कैप्शनिंग सेटिंग्स")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Configurações de legendagem ao vivo")
	return /** @type {LocalizedString} */ ("Live Captioning Settings")
});